import type { OnInit } from '@angular/core';
import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import Pikaday from 'pikaday';

@Component({
  standalone: false,
  selector: 'invd-fm-date-picker-mega',
  templateUrl: './fm-date-picker-mega.component.html',
  styleUrls: ['./fm-date-picker-mega.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class FmDatePickerMegaComponent implements OnInit {
  @Input() classNames: string;
  @Input() datePickerId: string;
  @Input() placeholderText: string;
  @Input() dateValue = 'mm/dd/yyyy';
  @Input() minDate: string = null;
  @Input() maxDate: string = null;
  /*This is Angular Array*/
  @Input() disableDates: Array<string> = null;
  @Input() disableWeekends = true;
  @Output() dateValueChange = new EventEmitter();

  private datePicker: Pikaday;
  private el = inject(ElementRef);

  ngOnInit(): void {
    this.initilizeDatePicker();
  }

  initilizeDatePicker(): void {
    const inputElement: HTMLElement = this.el.nativeElement.children[0];
    inputElement.setAttribute('id', this.datePickerId);
    const _minDate = this.minDate ? new Date(this.minDate) : null;
    const _maxDate = this.maxDate ? new Date(this.maxDate) : null;
    this.datePicker = new Pikaday({
      field: inputElement,
      format: 'MM/DD/YYYY',
      disableWeekends: this.disableWeekends,
      minDate: _minDate,
      maxDate: _maxDate,
      disableDayFn: this.disableDayFn,
    });
    /*
     * this.disableDates (angular Object) dates are not accessable in disableDayFn function (Jquery function)
     * using window.localStorage to pass this.disableDates (angular Object) in disableDayFn function (Jquery function)
     * */
    window.localStorage.setItem('disableDates', JSON.stringify(this.disableDates));

    if (+this.dateValue) {
      this.initDateValue(this.dateValue);
    }
  }
  /*This is Jquery Function*/
  public disableDayFn(theDate): any {
    const disableDates = JSON.parse(window.localStorage.getItem('disableDates'));
    if (
      disableDates &&
      disableDates.includes(
        new Date(theDate).toLocaleDateString('en-US', { timeZone: 'America/New_York' }),
      )
    ) {
      return true;
    }
    return null;
  }

  public initDateValue(val) {
    const newDate = new Date(val).toLocaleString(undefined, {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
    this.dateValue = newDate;
    this.datePicker.setDate(newDate);
  }

  dateInput() {
    this.datePicker.setDate(this.dateValue);
  }

  dateSelected(event) {
    const selectedDate = event.target.value as any;

    this.dateValueChange.emit(selectedDate);
  }

  @Input()
  set datePickerValue(dateValue: string) {
    this.dateValue = dateValue;
  }

  private setCalendarDate(_date: Date) {
    const inputElement: HTMLElement = this.el.nativeElement.children[0];
    inputElement.setAttribute('id', this.datePickerId);
    this.datePicker.destroy();
    this.datePicker = new Pikaday({ field: inputElement, format: 'MM/DD/YYYY' });
  }
}
